export default "/images/2f69319a3bb55032c9a8a12c5856d340.avif";